import React from 'react';
import { connect } from 'react-redux';
import Link from 'next/link';
import css from './Recommend.less';

const Recommend = props => {
  const { tuan } = props;
  const { recommentProducts } = tuan;
  if (recommentProducts.length <= 0) {
    return false;
  }
  return (
    <div className={css.contentMain}>
      <h2 className={`text-hidden-one ${css.title}`}>为您精选</h2>
      <ul>
        {recommentProducts.map(item => {
          return (
            <li className={css.item} key={item.id.toString()}>
              <Link
                href={{
                  pathname: '/tuan/[id]/',
                }}
                as={{
                  pathname: `/tuan/${item.id}/`,
                }}
                passHref
              >
                <a>
                  <div
                    className={`bg-cover ${css.avatar}`}
                    style={{
                      backgroundImage: `url(${item.recomment_cover_url})`,
                    }}
                  >
                    {' '}
                  </div>
                  <p className={`text-hidden-2 ${css.name}`}>{item.title}</p>
                  <p className={css.price}>
                    <span>¥</span>
                    {item.price}
                  </p>
                </a>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default connect(({ tuan }) => ({
  tuan,
}))(Recommend);
